$(document).ready( function(){
    
    $('input, select').on('focus', function(){
        $(this).closest('.error').removeClass('error').find('.error-tooltip').remove();
    });

    /* additional Product */
    // Create a hidden input for each selected additional product
    function additionalProductCheckbox() {
        $(".bdcsub .additional-product input:checkbox").prop('checked', false);
        var form = $('.bdcsub form');
        $(".bdcsub .additional-product").click(function (e) {
            var additionals = $(".additional-product input:checkbox:checked").map(function () {
                return $(this).val();
            }).get();
            $('input[data-additional]').remove();
            additionals.forEach(function(add, i) {
                var addInput = '<input type="hidden" data-additional value="' + add + '" name="additional[' + i + ']" id="additional[' + i + ']" />';
                form.append(addInput);
            });
        });
    }
    additionalProductCheckbox();
});